export const SCHOOL_SORT_BY_DISTANCE_VALUE = '0';
export const SCHOOL_SORT_ALPHABETICALLY_VALUE = '1';
export const SCHOOL_SORT_OPTIONS = [
    { value: SCHOOL_SORT_BY_DISTANCE_VALUE, label: 'Distance' },
    { value: SCHOOL_SORT_ALPHABETICALLY_VALUE, label: 'Alphabetical' },
];